<template>
  <div class="login">
    <div class="login__container" v-if="!modalSuccess">
      <img src="@\assets\logo-fundacion-forge.png" alt="">
      <h2>Comunidad de Educadores</h2>
      <h3>Ingresa el código de verificación que te enviamos a tu mail</h3>

      <div class="login-error" v-if="invalidActivationCode"><i class='material-icons'>error_outline</i>El código de verificación ingresado es incorrecto</div>
      <input @input="invalidActivationCode = false" type="text" placeholder="Código de verificación" v-model="activationCode" :class="{'input-invalid': (v$.activationCode.$invalid)}">
      <small class="input-message" v-if="v$.activationCode.required.$invalid"><i class='material-icons'>error_outline</i> {{v$.activationCode.required.$message}}</small>
      <div class="resend-code" @click.stop="resetModalResendCode(); modalResendCode.email = username; modalResendCode.active = true">Solicitar un código nuevo</div>

      <h4>Genera una contraseña</h4>

      <div class="password-requirements">
        <span>La contraseña debe tener:</span>
        <ul>
          <li>6 o más caracteres</li>
          <li>Al menos 1 mayúscula</li>
          <li>Al menos 1 número</li>
        </ul>
      </div>

      <input type="text" placeholder="Email" v-model="username" :class="{'input-invalid': (v$.username.$invalid)}">
      <small class="input-message" v-if="v$.username.required.$invalid"><i class='material-icons'>error_outline</i> {{v$.username.required.$message}}</small>
      <small class="input-message" v-if="v$.username.email.$invalid"><i class='material-icons'>error_outline</i> {{v$.username.email.$message}}</small>
      
      <div class="login-error" v-if="v$.passwordConfirm.sameAsPassword.$invalid && !v$.passwordConfirm.required.$invalid && !v$.password.required.$invalid && !invalidPassword">
        <i class='material-icons'>error_outline</i>{{v$.passwordConfirm.sameAsPassword.$message}} 
      </div>
      <div class="login-error" v-if="invalidPassword && !v$.password.required.$invalid"><i class='material-icons'>error_outline</i>La contraseña no cumple los requisitos</div>
      
      <div class="password_container">
        <input :type="passwordType" @input="validatePassword()" placeholder="Nueva contraseña" v-model="password" :class="{'input-invalid': (v$.password.$invalid)}">
        <i v-if="passwordType == 'password'" class="material-icons" @click.stop="passwordType = 'text'">visibility</i>
        <i v-else class="material-icons" @click.stop="passwordType = 'password'">visibility_off</i>
      </div>
      <small class="input-message" v-if="v$.password.required.$invalid"><i class='material-icons'>error_outline</i> {{v$.password.required.$message}}</small>

      <div class="password_container">
        <input :type="passwordType" placeholder="Confirmar contraseña" v-model="passwordConfirm" :class="{'input-invalid': (v$.passwordConfirm.$invalid)}">
        <i v-if="passwordType == 'password'" class="material-icons" @click.stop="passwordType = 'text'">visibility</i>
        <i v-else class="material-icons" @click.stop="passwordType = 'password'">visibility_off</i>
      </div>
      <small class="input-message" v-if="v$.passwordConfirm.required.$invalid"><i class='material-icons'>error_outline</i> {{v$.passwordConfirm.required.$message}}</small>

      <button @click="changePassword()" class="login-btn" :disabled="awaitRequest || v$.$invalid || (invalidPassword && !v$.password.required.$invalid)">{{ awaitRequest  ? 'Procesando' : 'Confirmar' }}<i class="material-icons">arrow_forward</i></button>    

    </div> <!-- /login-container -->

    <div v-else class="modalSuccess">
      <i class="material-icons">error_outline</i>
      <h4>Tu contraseña fue generada con éxito</h4>
      <p>Ya estamos listos.<br>Inicia sesión con tu nueva contraseña.</p>
      <div class="modalSuccess__actions">
        <button class="go-login" @click.stop="router.push('/login')">Iniciar sesión<i class="material-icons">arrow_forward</i></button>
      </div>
    </div>

    <div class="modal__overlay" v-if="modalResendCode.active" @click.stop="modalResendCode.success ? modalResendCode.active = false : ''">
      <div class="modalResendCode">
        <template v-if="!modalResendCode.success">
          <i class="material-icons">error_outline</i>
          <h4>¿No has recibido el código de verificación?</h4>
          <p>No hay problema. Enviaremos uno nuevo a:</p>
          <div class="modalResendCode__mail"><i class="material-icons-outlined">mail</i><span>{{modalResendCode.email}}</span></div>
          <div class="login-error" v-if="modalResendCode.error"><i class='material-icons'>error_outline</i>El mail ingresado no está registrado como usuario</div>
          <div class="modalResendCode__actions">
            <button class="cancel" @click.stop="modalResendCode.active = false; modalForgetPassword.error= ''">{{$t('global.CANCEL')}}</button>
            <button class="confirm" @click.stop="resendCode()" :disabled="modalResendCode.awaitRequest">{{modalResendCode.awaitRequest ? 'Enviando' : 'Continuar'}}<i class="material-icons">arrow_forward</i></button>
          </div>
        </template>
        <div v-else class="modal-resend-code__success">
          <i class="material-icons">error_outline</i>
          <h4>Código de verificación enviado</h4>
        </div>
      </div>
    </div>

  </div>
</template> 
<script>
import { useStore } from 'vuex';
import { ref, onBeforeUnmount, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import useVuelidate from '@vuelidate/core';
import { required, email, helpers, sameAs } from '@vuelidate/validators';

export default {
  components:{
    
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const username = ref("");
    const password = ref("");
    const passwordConfirm = ref("");
    const activationCode = ref("");
    const awaitRequest = ref(false);
    const v$ = useVuelidate();
    const submitted = ref(false);
    const passwordType = ref('password');
    const modalSuccess = ref(false);
    const modalResendCode = ref({
      active: false,
      email: '',
      awaitRequest: false,
      error: false,
      success : false
    });
    const resetModalResendCode = () => {
      modalResendCode.value.active = false, 
      modalResendCode.value.awaitRequest = false,
      modalResendCode.value.error = false,
      modalResendCode.value.success = false
    }
    const invalidActivationCode = ref(false);
    const invalidPassword = ref(false);
    
    function onKeydown (event) {
      if (event.key === 'Enter') {
        changePassword();
      }
    }

    window.addEventListener('keydown', onKeydown);

    onBeforeUnmount(() => {
      window.removeEventListener('keydown', onKeydown);
    })

    function validatePassword() {
      let validPassword = new RegExp(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]{6,32})$/); //eslint-disable-line
      validPassword.test(password.value) ? invalidPassword.value = false : invalidPassword.value = true ;
      return false;
    }
    
    async function changePassword () {
      submitted.value = true;
      awaitRequest.value = true;
      if (!v$.value.username.$invalid && !v$.value.password.$invalid && !v$.value.passwordConfirm.$invalid && !v$.value.activationCode.$invalid) {
        try {
          await store.dispatch('security_endPasswordRecovery', 
          {
            email: username.value, 
            password: password.value,
            passwordConfirm: passwordConfirm.value,
            activationCode: activationCode.value
          });
          modalSuccess.value = true;
        } catch (error) {
          if(error.response.data == 'Invalid code'){
            invalidActivationCode.value = true;
          }else{
            store.dispatch('notifications_create', { text: 'Ocurrió un error, intenta nuevamente' });
          }
          awaitRequest.value = false;
          submitted.value = false;
        }
      } else {
        awaitRequest.value = false;
      }
    }

    async function resendCode(){
      modalResendCode.value.awaitRequest = true;
      try {
        await store.dispatch('security_beginPasswordRecovery',{ email: modalResendCode.value.email })
        modalResendCode.value.success = true;
      } catch (error) {
        console.log(error)
        if(error.response.data == 'User does not exist'){
          modalResendCode.value.error = true; 
        }else{
          store.dispatch('notifications_create', { text: 'Error al enviar código, intenta nuevamente' });
        }
      } finally {
        modalResendCode.value.awaitRequest = false;
      }
    }

    onMounted(()=>{
      if(route.query.email) username.value = route.query.email;
      if(route.query.code) activationCode.value = route.query.code;
    })

    return {
      router,
      username,
      password,
      passwordConfirm,
      activationCode,
      changePassword,
      onKeydown,
      awaitRequest,
      v$,
      submitted,
      passwordType,
      modalSuccess,
      modalResendCode,
      resetModalResendCode,
      resendCode,
      invalidActivationCode,
      validatePassword,
      invalidPassword
    }
  },
  validations () {
    return {
      username: { 
        required: helpers.withMessage('Este campo es requerido', required),
        email: helpers.withMessage('El formato del mail es inválido', email)
      },
      password: { 
        required: helpers.withMessage('Este campo es requerido', required)
      },
      passwordConfirm: {
        required: helpers.withMessage('Este campo es requerido', required),
        sameAsPassword: helpers.withMessage('Las contraseñas no coinciden', sameAs(this.password))
      },
      activationCode: { 
        required: helpers.withMessage('Este campo es requerido', required)
      },
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
$modal-max-width: 520px;
$modal-border-radius: 8px;

.login {
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &__container {
    margin: 12px 0;
    width: 96%;
    max-width: $modal-max-width;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fff;
    padding: 26px 84px 26px 84px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
    border-radius: $modal-border-radius;
    @media screen and (max-width: 500px) {
      padding: 24px 18px 24px 18px;
    }
    img {
      width: 72px;
      margin: auto;
    }

    h2 {
      color: $black;
      font-weight: 700;
      text-align: center;
      font-size: 20px;
    }
    h3{
      margin-bottom: 8px;
      color: $black;
      font-weight: 600;
      text-align: center;
      font-size: 15px;
    }
    h4{
      margin-top: 8px;
      margin-bottom: 4px;
      color: $black;
      font-weight: 600;
      text-align: center;
      font-size: 15px;
    }
    input {
      height: 42px;
      width: 100%;
      padding: 12px 22px;
      margin-bottom: 8px;
      background: #f6f6f6;
      border: none;
      border-radius: 26px;
      color: #7d7d7d;
 
      &::placeholder {
        color: #7d7d7d;
      }

      &.input-invalid{
        color: $login-error-color;
        border: 1px solid $login-error-color;
      }
      &.input-invalid::placeholder {
        color: $login-error-color;
      }
    }

    .resend-code{
      margin-top: -11px;
      padding-right: 12px;
      padding-bottom: 4px;
      text-align: right;
      font-size: 13px;
      font-weight: 500;
      color: $green;
      text-decoration: underline;
      cursor: pointer;
    }

    .password-requirements{
      margin-bottom: 12px;
      @include flex-column;
      gap: 8px;
      font-size: 13px;
      font-weight: 600;
      ul li{
        list-style: disc inside;
      }
    }

    i {
      color: $green;
    }
  }
}

.input-message {
  margin-top: -12px;
  margin-bottom: 4px;
  padding-left: 12px;
  @include icon-and-text-container;
  gap: 4px;
  font-size: 13px;
  color: $login-error-color;
  .material-icons{
    font-size: 18px;
  }
}

.login-btn {
  @include icon-and-text-container;
  justify-content: center;
  padding: 8px 0;
  margin-top: 12px;
  background: $green;
  color: #fff;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  &:disabled {
    opacity: .45;
    cursor: default;
  }
}

.password_container{
  position: relative;
  width: 100%;
  height: fit-content;
  //display: flex;
  //align-items: center; 
  .material-icons {
    position: absolute;
    right: 0;
    top: 20%;
    padding-right: 12px;
    font-size: 24px;
    cursor: pointer;
    color: $black;
  }
}

input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus{
  transition: background-color 5000s ease-in-out 0s;
  font-size: 16px !important;
}

.modalResendCode, .modalSuccess{
  width: 96%;
  max-width: $modal-max-width;
  @include flex-column;
  gap: 12px;
  background: #fff;
  padding: 44px 40px 54px 40px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
  color: $darkgray;
  border-radius: $modal-border-radius;
  >.material-icons{
    font-size: 32px;
  }
  h4{
    color: $black;
    font-size: 17px;
    font-weight: 600;
  }
  p{
    font-size: 14px;
    font-weight: 500;
    color: $black;
  }
  &__mail{
    margin: 12px 0 16px 0;
    @include icon-and-text-container;
    span{
      font-weight: 600;
      color: $black;
    }
  }
  &__actions{
    display: flex;
    gap: 22px;
    button{
      @include icon-and-text-container;
      background: $green;
      padding: 8px 22px;
      border-radius: 24px;
      color: #fff;
      font-weight: 500;
      font-size: 17px;
      letter-spacing: .7px;
      &:disabled{
        opacity: .5;
        cursor: default;
      }
    }
    .cancel{
      background: none;
      color: $green;
      border: 1px solid $green;
    }
  }
  @media screen and (max-width: $bpSmall) {
    padding: 44px 20px 54px 20px;
    &__actions{
      display: flex;
      justify-content: space-between;
      gap: 12px;
      flex-wrap: wrap;
      button{
        padding: 8px 20px;
      }
    }
  }
}
.modalSuccess {
  p{
    text-align: center;
  }
  .go-login{
    margin-top: 16px;
  }
}
</style>